import logoUrl from "@/assets/schweisstechnik-logo.svg";

export const BrandMark = ({ size = 40, className = "" }) => {
  return (
    <img
      src={logoUrl}
      width={size}
      height={size}
      alt="Schweisstechnik Steyskal"
      className={`shrink-0 transition-all duration-300 ease-out ${className}`}
      style={{ width: size, height: size }}
    />
  );
};
